<template>
  <swiper ref="mySwiper" :options="swiperOptions"
  :style="{ borderRadius: radius, height }">
    <swiper-slide
      v-for="(item,index) in swipers"
      :key="index"
      :style="{ borderRadius: radius }"
    >
      <a
        class="slide-link"
        :href="getUrl(item.url)"
        target="_blank"
      >
        <img :src="getUrl(item.pic)">
      </a>
    </swiper-slide>

    <!-- <div v-show="dotShow" class="swiper-pagination" slot="pagination"></div> -->
  </swiper>
</template>

<script>
  export default {
    name: 'myswiper',
    props: {
      swipers: {
        type: Array,
        default: []
      },
      height: {
        type: String,
        default: 'auto'
      },
      radius: {
        type: [Number, String],
        default: 0
      },
      dotShow: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        swiperOptions: {
          pagination: {
            el: '.swiper-pagination'
          },
          autoplay: true,
          loop: true,
        },
        url: 'https://ccc.wangwanglive.com'
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    mounted() {
      setTimeout(() => {
         // this.swiper.slideTo(1, 1000, false)
      }, 1000);
    },
    methods: {
      linkGoTo(url) {
        console.log(url);
        window.open(url, "_blank");
      },
      getUrl(url) {
        let partten = /^(http|https).*$/;
        if (partten.test(url)) {
          return url;
        } else {
          return "https://ccc.wangwanglive.com" + url;
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .swiper-container {
    .slide-link {
      display: block;
      width: 100%;
      height: 100%;
    }
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/swiper.vue